<template>

  <div id="planet-transits">

    <div class="d-flex planet-selector-background flex-shrink-0 overflow-auto pb-3">
      <div v-for="planet of getPlanets" :key="planet.id" @click="selectPlanet(planet.id)"
           class="mx-1 flex-shrink-0 px-2 py-2 text-center planet-selection-box" style="min-width:50px;"
      :class="planet.id === selectedPlanet ? 'active' : ''">
        <span :class="`icon-${planet.icon}`"></span><p class="mb-0 text-sm">{{planet.name}}</p>
      </div>
    </div>



    <div class="py-4">
      <planet-overview :planet="getPlanetById(selectedPlanet)" />
    </div>

  </div>

</template>

<style lang="scss">

#planet-transits{

}
</style>

<script>
import TransitToolMixin from "../../../mixins/TransitToolMixin";
import {mapState} from "vuex";
import PlanetOverview from "./elements/planet-overview";
export default{

  components: {PlanetOverview},
  mixins: [TransitToolMixin],

  computed:{

    ...mapState({
      selectedPlanet: state => state.charts.transit.transitsSelectedPlanet
    })
  },

  mounted(){

  },

  data(){
    return{
    }
  },

  methods:{

    getPlanetById(id){
      return this.getPlanets.find(x => x.id === id);
    },
    selectPlanet(id){
      this.$store.commit('charts/SET_TRANSIT_SELECTED_PLANET', id);
    }

  }

}
</script>